import Component from 'vue-class-component'
import IconButton from '@/components/buttons/richmenu/IconButton';

@Component({
  name: 'h2-button',
})
export default class H2Button extends IconButton {
}
